export type NotificationStatus = 'Unread' | 'Read';

export const NotificationStatus: Record<
  NotificationStatus,
  NotificationStatus
> = {
  Unread: 'Unread',
  Read: 'Read',
};

export type NotificationType = 'Warning' | 'Info' | 'Danger';

export const NotificationType: Record<NotificationType, NotificationType> = {
  Warning: 'Warning',
  Info: 'Info',
  Danger: 'Danger',
};

export interface Notification {
  _id: string;
  message: string;
  recipientId: string;
  status: NotificationStatus;
  type: NotificationType;
  title: string;
  createdAt: string;
  updatedAt: string;
  timestamp: string;
}

export interface SendNotification {
  title: string;
  message: string;
}

export interface UpdateNotificationDto {
  notificationId: string | undefined;
  status: NotificationStatus;
}

export const NotificationTypeLabel: Record<NotificationType, string> = {
  Warning: 'Warning',
  Info: 'Info',
  Danger: 'Danger',
};
